import * as _ from 'lodash';
import { FormApi } from 'final-form';

export default class ZipCodeUtil {
    static getCityState(
        ownerType: string,
        zipCode: string,
        form: FormApi,
        getCityStateProp: (zipCode: string, ownerType?: string, form?: FormApi) => void
    ) {
        const values = form.getState().values;
        let stateId = '';
        let cityValue = '';

        if (ownerType === 'ownerJointTenant') {
            stateId = _.get(values, `${ownerType}.state.id`);
            cityValue = _.get(values, `${ownerType}.city`);
        } else {
            stateId = _.get(values, `${ownerType}.address.state.id`);
            cityValue = _.get(values, `${ownerType}.address.city`);
        }

        if (zipCode.length === 5 && !stateId && !cityValue) {
            getCityStateProp(zipCode, ownerType, form);
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/ZipCodeUtil.ts